import { Route, Routes } from 'react-router-dom';
import { AppShell } from './components/app-shell';
import { ToastStack } from './components/toast-stack';
import { FavoritesPage } from './pages/favorites-page';
import { HistoryPage } from './pages/history-page';
import { HomePage } from './pages/home-page';
import { LibraryPage } from './pages/library-page';
import { PlayerPage } from './pages/player-page';
import { QueuePage } from './pages/queue-page';
import { RemotePage } from './pages/remote-page';
import { SearchPage } from './pages/search-page';
import { SettingsPage } from './pages/settings-page';

export function App() {
  return (
    <>
      <Routes>
        <Route path="/remote" element={<RemotePage />} />
        <Route path="/play/:songId" element={<PlayerPage />} />
        <Route element={<AppShell />}>
          <Route index element={<HomePage />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="library" element={<LibraryPage />} />
          <Route path="favorites" element={<FavoritesPage />} />
          <Route path="queue" element={<QueuePage />} />
          <Route path="history" element={<HistoryPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
      </Routes>
      <ToastStack />
    </>
  );
}
